import { AppDispatch } from '../App/store'; // your store's dispatch type
import posService from '../API/PosService';

import { createAsyncThunk } from '@reduxjs/toolkit';

export const fetchStockItems = createAsyncThunk(
    'pos/fetchStockItems',
    async (_, thunkAPI) => {
        try {
            const data = await posService.getItemwiseStockOnline();
            return JSON.parse(data);
        } catch (error: any) {
            return thunkAPI.rejectWithValue(error.message || 'Fetch failed');
        }
    }
);


export const fetchPosItemOffers = createAsyncThunk(
  'pos/fetchPosItemOffers',
  async (membertype: string, thunkAPI) => {
    try {
      
      const data = await posService.getPosItemOffers(membertype);
      return JSON.parse(data);
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.message || 'Fetch Failed');
    }
  }
);


export const fetchPosCustomerDetails = createAsyncThunk('pos/fetchPosCustomerDetails',
    async(mobileNo:string,thunkAPI)=>{
        try{
            const data = await posService.getPosCustomerDetails(mobileNo)
            return data
        }
        catch(error:any){
            return thunkAPI.fulfillWithValue(error.message || 'fetchFailed')
        }
    })
